import {
  createFileRoute,
  linkOptions,
  redirect,
} from '@tanstack/react-router';

const scoutRequestLinkOptions = linkOptions({
  to: '/mydigitalworkers/scout/requests',
  from: '/mydigitalworkers/scout',
});

export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/',
)({
  beforeLoad: () => {
    throw redirect(scoutRequestLinkOptions);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <></>;
}
